var _circle, _path, _path2, _path3, _path4, _path5, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 49.9995,
    r: 50,
    fill: "#FDE0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.32 37.9995H33.68C30.9917 37.9995 29.6476 37.9995 28.6208 38.5227C27.7177 38.9829 26.9834 39.7172 26.5232 40.6204C26 41.6471 26 42.9913 26 45.6795V54.3195C26 57.0078 26 58.3519 26.5232 59.3787C26.9834 60.2818 27.7177 61.0162 28.6208 61.4763C29.6476 61.9995 30.9917 61.9995 33.68 61.9995H66.32C69.0083 61.9995 70.3524 61.9995 71.3792 61.4763C72.2823 61.0162 73.0166 60.2818 73.4768 59.3787C74 58.3519 74 57.0078 74 54.3195V45.6795C74 42.9913 74 41.6471 73.4768 40.6204C73.0166 39.7172 72.2823 38.9829 71.3792 38.5227C70.3524 37.9995 69.0083 37.9995 66.32 37.9995Z",
    fill: "#FFA6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6 49.9995C50.6 50.3309 50.3314 50.5995 50 50.5995C49.6686 50.5995 49.4 50.3309 49.4 49.9995C49.4 49.6681 49.6686 49.3995 50 49.3995C50.3314 49.3995 50.6 49.6681 50.6 49.9995Z",
    fill: "#FFA6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6 49.9995C62.6 50.3309 62.3314 50.5995 62 50.5995C61.6686 50.5995 61.4 50.3309 61.4 49.9995C61.4 49.6681 61.6686 49.3995 62 49.3995C62.3314 49.3995 62.6 49.6681 62.6 49.9995Z",
    fill: "#FFA6A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6 49.9995C38.6 50.3309 38.3314 50.5995 38 50.5995C37.6686 50.5995 37.4 50.3309 37.4 49.9995C37.4 49.6681 37.6686 49.3995 38 49.3995C38.3314 49.3995 38.6 49.6681 38.6 49.9995Z",
    fill: "#FFA6A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49.9995H50.012M62 49.9995H62.012M38 49.9995H38.012M33.68 37.9995H66.32C69.0083 37.9995 70.3524 37.9995 71.3792 38.5227C72.2823 38.9829 73.0166 39.7172 73.4768 40.6204C74 41.6471 74 42.9913 74 45.6795V54.3195C74 57.0078 74 58.3519 73.4768 59.3787C73.0166 60.2818 72.2823 61.0162 71.3792 61.4763C70.3524 61.9995 69.0083 61.9995 66.32 61.9995H33.68C30.9917 61.9995 29.6476 61.9995 28.6208 61.4763C27.7177 61.0162 26.9834 60.2818 26.5232 59.3787C26 58.3519 26 57.0078 26 54.3195V45.6795C26 42.9913 26 41.6471 26.5232 40.6204C26.9834 39.7172 27.7177 38.9829 28.6208 38.5227C29.6476 37.9995 30.9917 37.9995 33.68 37.9995ZM50.6 49.9995C50.6 50.3309 50.3314 50.5995 50 50.5995C49.6686 50.5995 49.4 50.3309 49.4 49.9995C49.4 49.6681 49.6686 49.3995 50 49.3995C50.3314 49.3995 50.6 49.6681 50.6 49.9995ZM62.6 49.9995C62.6 50.3309 62.3314 50.5995 62 50.5995C61.6686 50.5995 61.4 50.3309 61.4 49.9995C61.4 49.6681 61.6686 49.3995 62 49.3995C62.3314 49.3995 62.6 49.6681 62.6 49.9995ZM38.6 49.9995C38.6 50.3309 38.3314 50.5995 38 50.5995C37.6686 50.5995 37.4 50.3309 37.4 49.9995C37.4 49.6681 37.6686 49.3995 38 49.3995C38.3314 49.3995 38.6 49.6681 38.6 49.9995Z",
    stroke: "url(#paint0_linear_501_45058)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_501_45058)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78 49.9995L62.875 65.8884L56 58.6662",
    stroke: "#F24848",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_501_45058",
    x: 52,
    y: 45.9995,
    width: 32,
    height: 25.8889,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.423529 0 0 0 0 0.0392157 0 0 0 0 0.109804 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_501_45058"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_501_45058",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_501_45058",
    x1: 26,
    y1: 37.9995,
    x2: 74.7755,
    y2: 39.6954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.f19c66c737425a6e300a24e71c40d8f6.svg";
export { ForwardRef as ReactComponent };